<template>
  <button
    v-tooltip.top="button.name"
    class="toolbar_button"
    :class="{ 'is-active': isActive, disabled: disabled }"
    @click="onClick"
  >
    <svg-icon :width="'17'" :height="'13'" :icon="button.icon" :fill="fill" />
  </button>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Rect from '../../rect.js';
import Point from '../../point.js';
import SvgIcon from '../all/SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },

  props: {
    id: {
      type: Number,
      default: null,
    },
  },

  computed: {
    ...mapGetters('application/contextToolbar', ['getButtonById']),

    /**
     * Return whether the button is active or not.
     */
    isActive() {
      // console.log('isActive computed property on floating toolbar');
      if (this.button.isActiveCommand) {
        return this.button.isActiveCommand();
      }
      return null;
    },

    /**
     * Return whether the button is enabled or disabled.
     */
    disabled() {
      if (this.button.disabled) {
        return this.button.disabled();
      }
      return false;
    },

    /**
     * Return the button data
     */
    button() {
      return this.getButtonById(this.id);
    },

    /**
     * Return the fill for the svg icon. Undefined means default prop value for fill will be used.
     */
    fill() {
      return this.isActive ? '#db841e' : undefined;
    },
  },

  methods: {
    ...mapActions('application/contextToolbar', ['openSubmenu']),
    onClick() {
      console.log('Floating toolbar button on click');
      // Do nothing if the button is disabled
      if (this.button.disabled && this.button.disabled()) {
        return;
      }
      // Execute click command (if exists)
      if (this.button.clickCommand) {
        console.log('Executing click command:', this.button.clickCommand);
        this.button.clickCommand();
      }
      // Open submenu (if exists)
      if (this.button.submenu) {
        this.openSubmenu({
          buttonId: this.button.id,
          anchor: () => {
            const buttonRect = this.$el.getBoundingClientRect();
            const rect = new Rect(
              buttonRect.left,
              buttonRect.right,
              buttonRect.top,
              buttonRect.bottom
            );
            const parentRect = this.$parent.$el.getBoundingClientRect();
            const parentPt = new Point(parentRect.left, parentRect.top);
            rect.offsetRect(parentPt);
            return rect;
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar_button {
  border: none;
  background: transparent; // #242929;
  border-radius: 4px;
  width: 30px;
  height: 30px;
  margin-right: 5px;
  padding: 0;
  color: #c4c4c4;

  &:last-child {
    margin-right: 0;
  }

  &.disabled {
    cursor: default !important;
    .svg-icon-container {
      opacity: 0.5;
    }
  }

  &:hover {
    // background:#242929;
    color: #fff;
    cursor: pointer;
  }
  // &.is-active {
  //   // background:#0d0e0e;
  //   color: #db841e;
  //   .svg-icon-container {
  //     fill: #db841e !important;
  //   }
  // }
  .svg-icon-container {
    margin-bottom: 1px;
    .italic {
      margin-left: -1px;
    }
  }
}
</style>
